import { defineComponent as _defineComponent } from 'vue'
import searchIcon from "../../../assets/icon/search.svg";
import { ref, watch, onMounted } from "../../../adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUICore, { ExtensionInfo, TUIConstants } from "@tencentcloud/tui-core";
import { outsideClick } from "@tencentcloud/universal-api";
import Icon from "../../common/Icon.vue";
import searchMoreSVG from "../../../assets/icon/search-more.svg";
import { isPC, isUniFrameWork } from "../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  searchType: {
    type: String,
    default: "global", // "global" / "conversation"
    validator(value: string) {
      return ["global", "conversation"].includes(value);
    },
  },
},
  setup(__props) {

const props = __props



const searchMoreRef = ref<HTMLElement | null>();
const isListShow = ref<boolean>(false);
const toggleMore = () => {
  // isListShow.value = !isListShow.value;
  // if (!isUniFrameWork && isListShow.value) {
  //   outsideClick.listen({
  //     domRefs: searchMoreRef.value,
  //     handler: closeSearchMore,
  //   });
  // }
};
const extensionList = ref<ExtensionInfo[]>([]);

const handleMenu = (item: ExtensionInfo) => {
  const { listener = { onClicked: () => {} } } = item;
  listener?.onClicked?.(item);
  // toggleMore();
};

const closeSearchMore = () => {
  isListShow.value = false;
};

onMounted(() => {
  // extensions
  extensionList.value = [
    ...TUICore.getExtensionList(
      TUIConstants.TUISearch.EXTENSION.SEARCH_MORE.EXT_ID
    ),
  ];
  // hide conversation header
  TUICore.callService({
    serviceName: TUIConstants.TUIConversation.SERVICE.NAME,
    method:
      TUIConstants.TUIConversation.SERVICE.METHOD.HIDE_CONVERSATION_HEADER,
    params: {},
  });
});

watch(
  () => isListShow.value,
  () => {
    if (isListShow.value) {
      TUIStore.update(StoreName.SEARCH, "currentSearchingStatus", {
        isSearching: false,
        searchType: props.searchType,
      });
    }
  }
);

return { __sfc: true,props, searchMoreRef, isListShow, toggleMore, extensionList, handleMenu, closeSearchMore, searchIcon, Icon, isPC }
}

})